import React from "react";

import AudioElement from "./AudioElement";
import DocumentElement from "./DocumentElement";
import ImageElement from "./ImageElement";
import LinkElement from "./LinkElement";
import TextElement from "./TextElement";
import VideoElement from "./VideoElement";

const Element = ({ type, ...props }) => {
  switch (type) {
    case "text":
      return <TextElement {...props} />;
    case "image":
      return <ImageElement {...props} />;
    case "link":
      return <LinkElement {...props} />;
    case "video":
      return <VideoElement {...props} />;
    case "document":
      return <DocumentElement {...props} />;
    case "audio":
      return <AudioElement {...props} />;
    default:
      console.warn(`Unrecognised element: "${type}"`);
      return null;
  }
};

export default Element;
